import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import AuthService from "@/services/auth.service";
import { AxiosError } from "axios";
import { ErrorType } from "@/types/enums.type";
import { LoginFormDto, RegisterFormDto, ResetPasswordFormDto } from "@/types/user.type";

@Module({ namespaced: true })
class Auth extends VuexModule {
  loggedIn = false;
  errorMessage: string | null = "";
  errorType: ErrorType | null = null;
  confirmationSent = false;

  @Action({ rawError: true })
  async login(form: LoginFormDto): Promise<void> {
    try {
      this.context.commit("updateField", {
        path: "confirmationSent",
        value: false
      });

      const token = await AuthService.loginAsync(form);

      if (token) {   
        sessionStorage.setItem("token", token);

        const userInfo = await AuthService.userInfoAsync();

        sessionStorage.setItem('user-info', JSON.stringify(userInfo));
      }
    } catch (e: unknown) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user-info');
      const errorMessage = (e as AxiosError).response?.data.message;
      const errorType = (e as AxiosError).response?.data.type;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
      this.context.commit("updateField", {
        path: "errorType",
        value: errorType
      });
    }
  }

  @Action({ rawError: true })
  async storeUserInfo(): Promise<void> {
    try {
      const userInfo = await AuthService.userInfoAsync();
      
      sessionStorage.setItem('user-info', JSON.stringify(userInfo));
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async register(form: RegisterFormDto): Promise<void> {
    try {
      await AuthService.registerAsync(form);
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async resetPassword(form: ResetPasswordFormDto): Promise<void> {
    try {
      await AuthService.resetPasswordAsync(form);
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async requestPasswordReset(email: string): Promise<void> {
    try {
      return await AuthService.requestPasswordResetAsync({ email } as ResetPasswordFormDto);
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async resendConfirmation(form: LoginFormDto): Promise<void> {
    try {
      await AuthService.resendConfirmationAsnyc(form);
      this.context.commit("updateField", {
        path: "errorMessage",
        value: null
      });
      this.context.commit("updateField", {
        path: "errorType",
        value: null
      });
      this.context.commit("updateField", {
        path: "confirmationSent",
        value: true
      });
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      const errorType = (e as AxiosError).response?.data.type;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
      this.context.commit("updateField", {
        path: "errorType",
        value: errorType
      });
    }
  }
}

Auth.getters = { getField };
Auth.mutations = { updateField };

export default Auth;